// Endpoints
const OBHQ_ENDPOINTS = {
  GET: 'admin/queue_business_hours/fetch',
  CREATE_UPDATE: 'admin/queue_business_hours/create_update',
  DELETE: 'admin/queue_business_hours/delete',
  FORM_OPTIONS: 'admin/queue_business_hours/form_options',
};

// Day names map (day_of_week id -> name)
const DAY_NAMES = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

// Table headings
const tableHeadings = [
  { name: 'Queue Name', key: 1, width: 'tw-w-[20%]' },
  { name: 'Timezone', key: 2, width: 'tw-w-[10%]' },
  { name: 'Canned Response', key: 3, width: 'tw-w-[28%]' },
  { name: 'Business Hours', key: 4, width: 'tw-w-[24%]' },
  { name: 'Actions', key: 5, width: 'tw-w-[18%]' },
];

const rowStyles =
  'tw-px-3 tw-py-4 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-normal tw-align-top';

// Fixed defaults (not configurable from UI)
const FIXED_TIMEZONE = 'Asia/Kolkata';
const FIXED_MODE = 'canned';

export {
  OBHQ_ENDPOINTS,
  DAY_NAMES,
  tableHeadings,
  rowStyles,
  FIXED_TIMEZONE,
  FIXED_MODE,
};
